// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    PharmacyLongResponse,
    PharmacyModelResponse,
    PharmacySearchModel,
    PharmacySearchModelResponse,
    UpsearchModelPharmacyPharmacyUpsearchModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class PharmacyV2Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Get a Pharmacy by Tenant and Pharmacy identifiers
     * @param pharmacyId Pharmacy identifier.
     */
    public async pharmacyGetByTenantId (pharmacyId: number): Promise<AxiosResponse<PharmacyModelResponse>> {
        const _url_ = '/pharmacy/v2/Pharmacy/{pharmacyId}'
            .replace('{' + 'pharmacyId' + '}', encodeURIComponent(String(pharmacyId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'pharmacyId' is not null or undefined
        if (pharmacyId === null || pharmacyId === undefined) {
            throw new Error('Required parameter pharmacyId was null or undefined when calling pharmacyGetByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Search for existing Pharmacy
     * @param pharmacySearchModel PharmacySearchModel object
     */
    public async pharmacySearchByTenantId (pharmacySearchModel: PharmacySearchModel): Promise<AxiosResponse<PharmacySearchModelResponse>> {
        const _url_ = '/pharmacy/v2/PharmacySearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'pharmacySearchModel' is not null or undefined
        if (pharmacySearchModel === null || pharmacySearchModel === undefined) {
            throw new Error('Required parameter pharmacySearchModel was null or undefined when calling pharmacySearchByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(pharmacySearchModel, "PharmacySearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacySearchModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacySearchModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Upsearch Pharmacy
     * @param upsearchModelPharmacyPharmacyUpsearchModel Upsearch Model(PharmacyUpsearchModel) object
     */
    public async pharmacyUpsearchByTenantId (upsearchModelPharmacyPharmacyUpsearchModel: UpsearchModelPharmacyPharmacyUpsearchModel): Promise<AxiosResponse<PharmacyLongResponse>> {
        const _url_ = '/pharmacy/v2/PharmacyUpsearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'upsearchModelPharmacyPharmacyUpsearchModel' is not null or undefined
        if (upsearchModelPharmacyPharmacyUpsearchModel === null || upsearchModelPharmacyPharmacyUpsearchModel === undefined) {
            throw new Error('Required parameter upsearchModelPharmacyPharmacyUpsearchModel was null or undefined when calling pharmacyUpsearchByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(upsearchModelPharmacyPharmacyUpsearchModel, "UpsearchModelPharmacyPharmacyUpsearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PharmacyLongResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyLongResponse");
        }
        return response;
    }
}
